import { render } from "./join_game_block.vue?vue&type=template&id=592e67ae&scoped=true"
import script from "./join_game_block.vue?vue&type=script&lang=js"
export * from "./join_game_block.vue?vue&type=script&lang=js"

import "./join_game_block.vue?vue&type=style&index=0&id=592e67ae&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./join_game_block.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592e67ae"]])

export default __exports__